{
  "documentTitle": "Page introuvable",
  "heading": "Page introuvable",
  "backHome": "Retour à Launchpad"
}
